<template>
  <div>
    <b-dropdown-item v-b-modal="'modal-1' + index">
      Reply Comment
    </b-dropdown-item>
    <b-modal :id="'modal-1' + index" title="Reply">
      <b-alert variant="success" v-if="success" show> {{ success }}</b-alert>

      <b-form @submit.prevent="submitForm">
        <b-form-group
          id="input-group-1"
          label="Admin Reply:"
          label-for="input-1"
        >
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-form-input
              id="input-1"
              v-model="form.comment"
              type="text"
              placeholder="Reply Here"
              required
            ></b-form-input>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>
      </b-form>

      <template #modal-footer="{ close }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="submitForm()">
          Reply
        </b-button>
        <b-button size="sm" variant="danger" @click="close()"> Close </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  created() {
    console.log("clicked");
  },

  data() {
    return {
      form: {
        comment_id: "",
        comment: "",
      },
      success: false,

      options: [],
    };
  },
  props: ["index", "data"],

  methods: {
    submitForm() {
      this.form.comment_id = this.data._id;
      window.axios.post("/comment/admin", this.form).then((resp) => {
        if (resp.data.success) {
          this.$emit("comment-success", resp.data.success);
        }
      });
    },
  },
};
</script>

<style scoped>
.edit-icon {
  border: none;
  color: #68561d;
  background-color: #fff;
  margin: 0;
  padding-bottom: 2px;
  margin-left: 10px;
}
.fa-edit {
  height: 18px;
  width: 30px;
}
</style>
